export default {
  socio: state => state.socio
};
